export const CREATE_ITEM_CLOSING_RATE  = 'CREATE_ITEM_CLOSING_RATE';
export const GET_ALL_ITEM_CLOSING_RATE  = 'GET_ALL_ITEM_CLOSING_RATE';
export const ITEM_CLOSING_RATE_REQUEST  = 'ITEM_CLOSING_RATE_REQUEST';
export const UPDATE_ALL_ITEM_CLOSING_RATE  = 'UPDATE_ALL_ITEM_CLOSING_RATE';
export const ITEM_CLOSING_RATE_REQUEST_FAILURE  = 'ITEM_CLOSING_RATE_REQUEST_FAILURE';